
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subcontracting",
      function () {
        return require("private-next-pages/subcontracting.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/subcontracting"])
      });
    }
  